
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34234',
  depVersions: {
  "documents-public-ui": "static-1.34234",
  "client-types": "static-1.456",
  "documents-lib": "static-1.34239",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2023",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4921",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5489",
  "hs-test-utils": "static-1.7906",
  "hub-http": "static-1.6113",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11346",
  "I18n": "static-7.1600",
  "jasmine-immutable": "static-1.2912",
  "jasmine-runner": "static-1.6364",
  "lodash": "static-1.3",
  "quartz": "static-1.6861",
  "react": "static-7.184",
  "react-dlb": "static-1.76",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16549",
  "reporting-data": "static-1.67001",
  "reporting-testing-lib": "static-1.8934",
  "reporting-visualizations": "static-1.59077",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4664",
  "webpack-env": "static-1.54",
  "atom": "static-1.4965",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2388",
  "classnames": "static-2.10",
  "cssUtils": "static-1.766",
  "customer-data-filters-ui": "static-1.39326",
  "customer-data-objects": "static-1.7551",
  "customer-data-property-utils": "static-1.7978",
  "data-fetching-client": "static-1.9570",
  "enviro": "static-4.425",
  "FireAlarmUi": "static-1.4424",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85563",
  "FormUrlGenerator": "static-2.4614",
  "foundations-components": "static-1.7710",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11654",
  "icons": "static-2.639",
  "immutable": "static-2.76",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7054",
  "metrics-js": "static-1.9522",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.386",
  "property-description-translator": "static-1.3748",
  "property-translator": "static-1.5303",
  "quartz-config": "static-1.639",
  "quartz-core": "static-1.6080",
  "quick-fetch": "static-1.3829",
  "raven": "static-3.5808",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5262",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8061",
  "reference-resolvers-lite": "static-1.7984",
  "report-customization-components": "static-1.12821",
  "reporting-enablement": "static-1.22490",
  "reporting-reports": "static-1.66679",
  "reporting-snowflake": "static-1.55619",
  "reporting-ui-components": "static-2.64272",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4538",
  "sales-content-partitioning": "static-1.8832",
  "SalesContentIndexUI": "static-3.9075",
  "sanitize": "static-1.4367",
  "sanitize-text": "static-1.8039",
  "self-service-api": "static-1.10140",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1646",
  "signup-constants": "static-1.18644",
  "signup-ui-lego-core": "static-1.20654",
  "signup-ui-url-generator": "static-2.7934",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4664",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10886",
  "ui-addon-i18n": "static-1.11042",
  "ui-addon-react-router-dom": "static-1.9439",
  "ui-addon-upgrades": "static-9.17832",
  "ui-asset-management-lib": "static-1.10869",
  "ui-images": "static-2.1127",
  "UIComponents": "static-3.8293",
  "usage-tracker": "static-1.7231",
  "usage-tracker-container": "static-1.7221",
  "usage-tracker-core": "static-1.7081",
  "usage-tracker-public": "static-1.7042",
  "viral-links-lib": "static-1.6933",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven-hubspot": "static-1.6115",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3320",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3138",
  "quartz-webpack": "static-1.3085",
  "ai-components-ui-library": "static-1.8667",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4741",
  "foundations-theming": "static-1.4307",
  "quartz-auth": "static-1.536",
  "ui-business-units-lib": "static-1.8935",
  "usage-tracker-session-replay": "static-1.4917",
  "foundations-theming-base": "static-1.3292",
  "HeadJS": "static-2.734",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3017",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4219",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7819",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3503",
  "persist-promise": "static-1.3603",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.735",
  "hs-story-utils": "static-1.9324",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9718",
  "hubspotter-http": "static-1.4566",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7144",
  "crm-message-bus": "static-1.42685",
  "customer-data-filters-ui-msw-helpers": "static-1.21761",
  "customer-data-objects-ui-components": "static-1.12913",
  "customer-data-reference-ui-components": "static-1.13048",
  "customer-data-ui-utilities": "static-1.9720",
  "framework-builder-read-service-client": "static-1.3922",
  "framework-data-schema-quick-fetch": "static-1.6675",
  "framework-data-schema-resolvers": "static-1.6770",
  "inbound-db-properties-service-client": "static-1.3760",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16407",
  "reporting-datasets-permissions-lib": "static-1.13368",
  "ui-addon-teams": "static-1.21401",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68020",
  "customer-data-properties": "static-1.51164",
  "forms-ai-lib": "static-1.4152",
  "forms-utils-lib": "static-1.12379",
  "foundations-components-test-utils": "static-1.5193",
  "react-dnd-compat": "static-1.4513",
  "react-tinymce": "static-1.54929",
  "tinymce-config": "static-2.54055",
  "ui-gdpr-components": "static-1.10243",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3979",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1519",
  "ui-fonts": "static-1.608",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.818",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.526",
  "quartz-i18n": "static-1.536",
  "quartz-routing": "static-1.291",
  "quartz-test": "static-1.536",
  "quartz-tracking": "static-1.240",
  "batch-promise": "static-1.1446",
  "external-options-client-types": "static-1.4072",
  "react-colorpicker": "static-2.10104",
  "copilot-toolkit": "static-1.10831",
  "data-quality-ui-library": "static-1.12592",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6358",
  "reporting-action-components": "static-1.40960",
  "reporting-insights-lib": "static-1.1400",
  "reporting-plugins": "static-1.10128",
  "ui-addon-draggable-compat": "static-2.4149",
  "ui-addon-opt": "static-4.8277",
  "ui-shepherd-react": "static-3.10042",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25045",
  "hubspot-apollo-client": "static-1.4773",
  "chirp-fetch": "static-1.1776",
  "sales-templates-service-types-lib": "static-1.4080",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5671",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.3992",
  "timezone-utils": "static-2.5139",
  "bender-build-tools": "static-1.3062",
  "chatspot-core": "static-1.20787",
  "bend-plugin-foundations-theming": "static-1.2790",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9716",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3711",
  "crm-pipelines-api-client-types": "static-1.4056",
  "multi-currency-client-types": "static-1.3603",
  "getting-started-shared-tasks": "static-1.18193",
  "growth-data-modal": "static-1.5266",
  "growth-onboarding-confetti": "static-1.2966",
  "growth-onboarding-next-action-utils": "static-1.1600",
  "navigation-components": "static-1.17631",
  "onboarding-tours-client": "static-1.4621",
  "onboarding-tours-utils": "static-1.473",
  "ui-shepherd-tracker": "static-1.7423",
  "ui-universal-auth": "static-1.8827",
  "user-context": "static-1.4994",
  "cms-field-types": "static-1.4704",
  "content-icons-ui": "static-1.2199",
  "integrations-lib": "static-1.15765",
  "calling-global-api": "static-1.64091",
  "calling-internal-common": "static-1.31196",
  "calling-lifecycle-internal": "static-1.65473",
  "calling-lifecycle-messages": "static-1.57767",
  "commerce-products-lib": "static-1.9138",
  "crm-links": "static-1.6170",
  "file-manager-components": "static-1.23279",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.33",
  "inbounddb-objects-service-types": "static-1.4137",
  "meetings-icalendar-utils-lib": "static-1.525",
  "object-builder-ui-client": "static-1.48378",
  "pipeline-validation-client-types": "static-1.3879",
  "property-value-citations": "static-1.1778",
  "pulse": "static-1.434",
  "smart-property-lib": "static-1.6415",
  "tiered-pricing": "static-1.1002",
  "ui-addon-iframeable": "static-1.8944",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19648",
  "tinymce-themes": "static-1.56025",
  "data-token-picker": "static-1.16219",
  "hub-http-contrib": "static-1.2938",
  "interframe": "static-3.4658",
  "tinymce-data": "static-1.40140",
  "tinymce-plugins": "static-1.57169",
  "ui-addon-sales-email": "static-1.5106",
  "magpie-lib": "static-1.5488",
  "magpie-types": "static-1.4948",
  "simple-logging-lib": "static-1.2946",
  "content-assistance-lib": "static-1.7593",
  "dashboard-lib": "static-1.81079",
  "ExportDialog": "static-6.10285",
  "hubspot-prosemirror": "static-1.17927",
  "hubspot-prosemirror-plugins": "static-1.17919",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8589",
  "campaign-roi-lib": "static-1.8621",
  "feedback-loader": "static-1.29099",
  "apollo-link-hub-http": "static-2.4545",
  "hubspot-apollo-cache": "static-1.232",
  "growth-monetization-service-types": "static-1.4396",
  "nav-client-types": "static-1.2253",
  "purchase-motions-api": "static-1.5674",
  "trials-service-types": "static-1.3797",
  "onboarding-data-sync-lib": "static-1.1782",
  "growth-onboarding-next-action-components": "static-1.1628",
  "user-context-client": "static-1.4506",
  "idb-keyval": "static-1.42",
  "nest": "static-1.116",
  "reactive-lib": "static-1.619",
  "unified-auth-core-lib": "static-1.622",
  "getting-started-shared-tasks-store": "static-1.17311",
  "integrations-error-boundary-lib": "static-1.13180",
  "integrations-tracking-lib": "static-1.5490",
  "native-integrations-shared-strings": "static-1.7681",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10268",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.341",
  "calling-error-reporting": "static-1.31202",
  "shared-worker-versioning": "static-1.10933",
  "calling-usage-tracker": "static-1.6436",
  "voice-sms-access-library": "static-1.582",
  "customer-data-tracking": "static-1.6778",
  "commerce-permissions": "static-1.660",
  "products-iframe-lib": "static-1.7628",
  "products-ui-components-shared-msw-handlers": "static-1.10100",
  "location-customization-utils-lib": "static-1.8902",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4048",
  "video-components-external": "static-1.10928",
  "video-data-lib": "static-1.34586",
  "directed-graph": "static-1.832",
  "event-emitter": "static-1.843",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.24",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9801",
  "fsm": "static-1.3628",
  "policy-lib": "static-1.6677",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9864",
  "navigation-messaging": "static-1.6958",
  "FileManagerLib": "static-1.38919",
  "NamespacedHubStyle": "static-2.8982",
  "FileManagerCore": "static-1.38778",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12239",
  "layout-dnd-utils": "static-1.11214",
  "react-codemirror": "static-1.10518",
  "ui-addon-emoji-picker": "static-1.9782",
  "ui-brand-identity-lib": "static-1.14762",
  "ui-addon-video-player": "static-1.8591",
  "ui-coaching-tips": "static-1.28240",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23226",
  "EmailSignatureEditor": "static-1.24140",
  "eligibility-engine-service-types": "static-1.3078",
  "InboxConnectUtils": "static-4.14514",
  "universal-page-editor-lib": "static-1.2901",
  "calling-orchestration-schema": "static-1.35359",
  "sales-views-client-types": "static-1.4158",
  "crm-record-cards-service-types": "static-1.3524",
  "content-media-composition-data-lib": "static-1.11884",
  "content-media-compositions": "static-2.15891",
  "media-bridge-lib": "static-1.18739",
  "trellis-story-utils": "static-1.4414",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5756",
  "FileManagerImages": "static-1.36430",
  "video-components": "static-1.12931",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4426",
  "video-embed": "static-1.35420",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68095",
  "layout-data-lib": "static-1.9539",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6476",
  "commerce-tours-lib": "static-1.5899",
  "growth-onboarding-reliability": "static-1.4981",
  "sales-checkout-service-client": "static-1.3563",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21488",
  "sales-email-signature-service-client": "static-1.3738",
  "social-insights-client-types": "static-1.21761",
  "outpost": "static-1.4089",
  "advanced-menus-core": "static-1.14962",
  "advanced-menus-lib": "static-1.11925",
  "ui-memberships-settings-lib": "static-1.33747",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14961",
  "simple-menus-lib": "static-1.16478"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34234",
  "client-types": "/client-types/static-1.456",
  "documents-lib": "/documents-lib/static-1.34239",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2023",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4921",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5489",
  "hs-test-utils": "/hs-test-utils/static-1.7906",
  "hub-http": "/hub-http/static-1.6113",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11346",
  "I18n": "/I18n/static-7.1600",
  "jasmine-immutable": "/jasmine-immutable/static-1.2912",
  "jasmine-runner": "/jasmine-runner/static-1.6364",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6861",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.76",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16549",
  "reporting-data": "/reporting-data/static-1.67001",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8934",
  "reporting-visualizations": "/reporting-visualizations/static-1.59077",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4664",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4965",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2388",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.766",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39326",
  "customer-data-objects": "/customer-data-objects/static-1.7551",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7978",
  "data-fetching-client": "/data-fetching-client/static-1.9570",
  "enviro": "/enviro/static-4.425",
  "FireAlarmUi": "/FireAlarmUi/static-1.4424",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85563",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4614",
  "foundations-components": "/foundations-components/static-1.7710",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11654",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.76",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7054",
  "metrics-js": "/metrics-js/static-1.9522",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "property-description-translator": "/property-description-translator/static-1.3748",
  "property-translator": "/property-translator/static-1.5303",
  "quartz-config": "/quartz-config/static-1.639",
  "quartz-core": "/quartz-core/static-1.6080",
  "quick-fetch": "/quick-fetch/static-1.3829",
  "raven": "/raven/static-3.5808",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5262",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8061",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7984",
  "report-customization-components": "/report-customization-components/static-1.12821",
  "reporting-enablement": "/reporting-enablement/static-1.22490",
  "reporting-reports": "/reporting-reports/static-1.66679",
  "reporting-snowflake": "/reporting-snowflake/static-1.55619",
  "reporting-ui-components": "/reporting-ui-components/static-2.64272",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4538",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8832",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9075",
  "sanitize": "/sanitize/static-1.4367",
  "sanitize-text": "/sanitize-text/static-1.8039",
  "self-service-api": "/self-service-api/static-1.10140",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1646",
  "signup-constants": "/signup-constants/static-1.18644",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20654",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7934",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4664",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10886",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11042",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9439",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17832",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10869",
  "ui-images": "/ui-images/static-2.1127",
  "UIComponents": "/UIComponents/static-3.8293",
  "usage-tracker": "/usage-tracker/static-1.7231",
  "usage-tracker-container": "/usage-tracker-container/static-1.7221",
  "usage-tracker-core": "/usage-tracker-core/static-1.7081",
  "usage-tracker-public": "/usage-tracker-public/static-1.7042",
  "viral-links-lib": "/viral-links-lib/static-1.6933",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3320",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3138",
  "quartz-webpack": "/quartz-webpack/static-1.3085",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8667",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4741",
  "foundations-theming": "/foundations-theming/static-1.4307",
  "quartz-auth": "/quartz-auth/static-1.536",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8935",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4917",
  "foundations-theming-base": "/foundations-theming-base/static-1.3292",
  "HeadJS": "/HeadJS/static-2.734",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3017",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4219",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7819",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3503",
  "persist-promise": "/persist-promise/static-1.3603",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.735",
  "hs-story-utils": "/hs-story-utils/static-1.9324",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9718",
  "hubspotter-http": "/hubspotter-http/static-1.4566",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7144",
  "crm-message-bus": "/crm-message-bus/static-1.42685",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21761",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12913",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13048",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9720",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3922",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6675",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6770",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3760",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16407",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13368",
  "ui-addon-teams": "/ui-addon-teams/static-1.21401",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68020",
  "customer-data-properties": "/customer-data-properties/static-1.51164",
  "forms-ai-lib": "/forms-ai-lib/static-1.4152",
  "forms-utils-lib": "/forms-utils-lib/static-1.12379",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5193",
  "react-dnd-compat": "/react-dnd-compat/static-1.4513",
  "react-tinymce": "/react-tinymce/static-1.54929",
  "tinymce-config": "/tinymce-config/static-2.54055",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10243",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3979",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1519",
  "ui-fonts": "/ui-fonts/static-1.608",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.818",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.526",
  "quartz-i18n": "/quartz-i18n/static-1.536",
  "quartz-routing": "/quartz-routing/static-1.291",
  "quartz-test": "/quartz-test/static-1.536",
  "quartz-tracking": "/quartz-tracking/static-1.240",
  "batch-promise": "/batch-promise/static-1.1446",
  "external-options-client-types": "/external-options-client-types/static-1.4072",
  "react-colorpicker": "/react-colorpicker/static-2.10104",
  "copilot-toolkit": "/copilot-toolkit/static-1.10831",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12592",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6358",
  "reporting-action-components": "/reporting-action-components/static-1.40960",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1400",
  "reporting-plugins": "/reporting-plugins/static-1.10128",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4149",
  "ui-addon-opt": "/ui-addon-opt/static-4.8277",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10042",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25045",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4773",
  "chirp-fetch": "/chirp-fetch/static-1.1776",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4080",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5671",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.3992",
  "timezone-utils": "/timezone-utils/static-2.5139",
  "bender-build-tools": "/bender-build-tools/static-1.3062",
  "chatspot-core": "/chatspot-core/static-1.20787",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2790",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9716",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3711",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4056",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3603",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18193",
  "growth-data-modal": "/growth-data-modal/static-1.5266",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2966",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1600",
  "navigation-components": "/navigation-components/static-1.17631",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4621",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.473",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7423",
  "ui-universal-auth": "/ui-universal-auth/static-1.8827",
  "user-context": "/user-context/static-1.4994",
  "cms-field-types": "/cms-field-types/static-1.4704",
  "content-icons-ui": "/content-icons-ui/static-1.2199",
  "integrations-lib": "/integrations-lib/static-1.15765",
  "calling-global-api": "/calling-global-api/static-1.64091",
  "calling-internal-common": "/calling-internal-common/static-1.31196",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65473",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57767",
  "commerce-products-lib": "/commerce-products-lib/static-1.9138",
  "crm-links": "/crm-links/static-1.6170",
  "file-manager-components": "/file-manager-components/static-1.23279",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.33",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4137",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.525",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48378",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3879",
  "property-value-citations": "/property-value-citations/static-1.1778",
  "pulse": "/pulse/static-1.434",
  "smart-property-lib": "/smart-property-lib/static-1.6415",
  "tiered-pricing": "/tiered-pricing/static-1.1002",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8944",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19648",
  "tinymce-themes": "/tinymce-themes/static-1.56025",
  "data-token-picker": "/data-token-picker/static-1.16219",
  "hub-http-contrib": "/hub-http-contrib/static-1.2938",
  "interframe": "/interframe/static-3.4658",
  "tinymce-data": "/tinymce-data/static-1.40140",
  "tinymce-plugins": "/tinymce-plugins/static-1.57169",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5106",
  "magpie-lib": "/magpie-lib/static-1.5488",
  "magpie-types": "/magpie-types/static-1.4948",
  "simple-logging-lib": "/simple-logging-lib/static-1.2946",
  "content-assistance-lib": "/content-assistance-lib/static-1.7593",
  "dashboard-lib": "/dashboard-lib/static-1.81079",
  "ExportDialog": "/ExportDialog/static-6.10285",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17927",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17919",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8589",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8621",
  "feedback-loader": "/feedback-loader/static-1.29099",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4545",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.232",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4396",
  "nav-client-types": "/nav-client-types/static-1.2253",
  "purchase-motions-api": "/purchase-motions-api/static-1.5674",
  "trials-service-types": "/trials-service-types/static-1.3797",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1782",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1628",
  "user-context-client": "/user-context-client/static-1.4506",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.116",
  "reactive-lib": "/reactive-lib/static-1.619",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.622",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17311",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13180",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5490",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7681",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10268",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.341",
  "calling-error-reporting": "/calling-error-reporting/static-1.31202",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10933",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6436",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.582",
  "customer-data-tracking": "/customer-data-tracking/static-1.6778",
  "commerce-permissions": "/commerce-permissions/static-1.660",
  "products-iframe-lib": "/products-iframe-lib/static-1.7628",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10100",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8902",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4048",
  "video-components-external": "/video-components-external/static-1.10928",
  "video-data-lib": "/video-data-lib/static-1.34586",
  "directed-graph": "/directed-graph/static-1.832",
  "event-emitter": "/event-emitter/static-1.843",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.24",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9801",
  "fsm": "/fsm/static-1.3628",
  "policy-lib": "/policy-lib/static-1.6677",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9864",
  "navigation-messaging": "/navigation-messaging/static-1.6958",
  "FileManagerLib": "/FileManagerLib/static-1.38919",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8982",
  "FileManagerCore": "/FileManagerCore/static-1.38778",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12239",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11214",
  "react-codemirror": "/react-codemirror/static-1.10518",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9782",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14762",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8591",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28240",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23226",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24140",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3078",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14514",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2901",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35359",
  "sales-views-client-types": "/sales-views-client-types/static-1.4158",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3524",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11884",
  "content-media-compositions": "/content-media-compositions/static-2.15891",
  "media-bridge-lib": "/media-bridge-lib/static-1.18739",
  "trellis-story-utils": "/trellis-story-utils/static-1.4414",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5756",
  "FileManagerImages": "/FileManagerImages/static-1.36430",
  "video-components": "/video-components/static-1.12931",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4426",
  "video-embed": "/video-embed/static-1.35420",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68095",
  "layout-data-lib": "/layout-data-lib/static-1.9539",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6476",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5899",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4981",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3563",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21488",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3738",
  "social-insights-client-types": "/social-insights-client-types/static-1.21761",
  "outpost": "/outpost/static-1.4089",
  "advanced-menus-core": "/advanced-menus-core/static-1.14962",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11925",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33747",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14961",
  "simple-menus-lib": "/simple-menus-lib/static-1.16478"
}
};
